import { store } from 'redux/store';
import { FC } from 'react';

import { Board, Council, Society } from 'types';

import { useGetBoardsSectionPermissions } from 'modules/boards/hooks/useGetBoardsSectionPermissions';
import { setModal } from 'modules/_shared/redux/modalActions';

import actionTypes from 'constants/actionTypes';
import sizes from 'constants/sizes';

import BoardDetailsInfoCardHeader from '../BoardDetailsDocumentsCard/components/BoardDetailsInfoCardHeader';
import BoardDetailsInfoCardBody from '../BoardDetailsDocumentsCard/components/BoardDetailsInfoCardBody';
import { boardEntityTypes } from '../BoardsListHeader/constants/boardEntityTypes';
import AddBasicBoardModal from '../Modals/AddBasicBoard';
import { AddBasicBoardModalProvider } from '../Modals/AddBasicBoard/context/AddBasicBoardModalContext';

type BoardDetailsInfoCardProps = {
  board: Board | Council | undefined;
  boardType?: string;
};

const BoardDetailsInfoCard: FC<BoardDetailsInfoCardProps> = ({
  board,
  boardType,
}) => {
  const { isAdmin } = useGetBoardsSectionPermissions().data;

  const handleEditBoard = () => {
    if (boardType === boardEntityTypes.BASIC_BOARD) {
      store.dispatch(
        setModal(
          <AddBasicBoardModalProvider
            actionType={actionTypes.EDIT}
            size={sizes.XL}
            boardData={board as Board}
          >
            <AddBasicBoardModal />
          </AddBasicBoardModalProvider>
        )
      );
    }
  };

  return (
    <section className="board-member-basic-info-card col mb-5">
      <BoardDetailsInfoCardHeader
        isAdmin={isAdmin}
        onClickEdit={handleEditBoard}
      />

      <BoardDetailsInfoCardBody board={board} />
    </section>
  );
};

export default BoardDetailsInfoCard;
